import { useCallback, useState } from 'react';
import { muteAll, useFetchOld } from 'hooks';
import { addAssetToWatchlist, removeAssetFromWatchlist, } from '../actions';
const useAddRemoveSymbolFromWatchList = (watchListId) => {
    const [loading, setLoading] = useState(false);
    const [, , , addSymbolToWatchListFetch] = useFetchOld(muteAll);
    const [, , , removeAssetFromWatchListFetch] = useFetchOld(muteAll);
    const addSymbolToWatchList = useCallback(async (symbol, assetId, name) => {
        setLoading(true);
        await addSymbolToWatchListFetch(addAssetToWatchlist(watchListId, symbol, assetId, name));
        setLoading(false);
    }, [addSymbolToWatchListFetch, watchListId]);
    const removeSymbolFromWatchList = useCallback(async (symbol, assetId) => {
        setLoading(true);
        await removeAssetFromWatchListFetch(removeAssetFromWatchlist(watchListId, symbol, assetId));
        setLoading(false);
    }, [removeAssetFromWatchListFetch, watchListId]);
    return [loading, addSymbolToWatchList, removeSymbolFromWatchList];
};
export default useAddRemoveSymbolFromWatchList;
